export default __webpack_public_path__ + "static/Swiss721BT-Light-863cbad738215ee57a0fbc766aa1c4e8.woff";